document.addEventListener('DOMContentLoaded', function () {

  const rideAddons =
    document.querySelectorAll('.ride-addon-checkbox');

  if (!rideAddons.length) {
    return;
  }

  const productForms =
    document.querySelectorAll(
      'form[action*="/cart/add"]:not(.installment)'
    );

  productForms.forEach(function (form) {

    form.addEventListener('submit', function () {

      const selectedAddons =
        Array.from(rideAddons)
          .filter(function (checkbox) {
            return checkbox.checked;
          })
          .map(function (checkbox) {
            return {
              id: Number(checkbox.dataset.variantId),
              quantity: 1,
              properties: {
                '_ship_with_ride': 'yes'
              }
            };
          });

      if (!selectedAddons.length) {
        return;
      }

      /*
       * Allow Shopify / Simple Bundles to add
       * the main product first.
       */
      setTimeout(async function () {

        try {

          const response = await fetch(
            window.Shopify.routes.root + 'cart/add.js',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                items: selectedAddons
              })
            }
          );

          if (!response.ok) {
            throw new Error(
              `Accessory add failed: ${response.status}`
            );
          }

          const result =
            await response.json();

          console.log(
            'Ride accessories added:',
            result
          );

          document.dispatchEvent(
            new CustomEvent('cart:refresh')
          );

        } catch (error) {

          console.error(
            'Unable to add Ride accessories:',
            error
          );

        }

      }, 500);

    });

  });

});